import React, { useState, useEffect } from "react";
import { config } from "../App";
import { Stack, TextField, InputAdornment, Button, Grid } from "@mui/material";
import { Search, FileUpload } from "@mui/icons-material";
import SortButton from "./SortButton";
import "./LandingPage.css";
import logo from "../Logo.png";
import axios from "axios";
import LandingPageVideo from "./LandingPageVideo";
import qs from "qs";
import UploadModal from "./UploadModal";
import { useSnackbar } from "notistack";

const LandingPage = () => {
  const { enqueueSnackbar } = useSnackbar();


  const [Videos, setVideos] = useState([]);
  const [debounceTimeout, setDebounceTimeout] = useState();
  const [showModal,setShowModal]=useState(false)
  const fecthVideos = async () => {
    try {
      const response = await axios.get(`${config.endpoint}`);
      console.log(response.data);
      setVideos(response.data["videos"]);
    } catch (err) {
      if(err.response.status===404)
      enqueueSnackbar("Cannot find any videos at the moment. Please try again later.",{variant:"error"})
      console.log(err);
    
    }
  };

  useEffect(() => {
    fecthVideos();
  }, []);

  const performAPISort = async (sort) => {
    try {
      const response = await axios.get(`${config.endpoint}?sortBy=${sort}`);
      console.log(response.data);
      setVideos(response.data.videos);
    } catch (err) {
      console.log(err);
    }
  };

  const selectedMultiValue = [];
  let ratings;
  let searchBarValue;
  const performAPISearch = async (searchValue, genreValue, ratingValue) => {
    // console.log("selectedValue:",selectedMultiValue);

    if (genreValue!==null){
      selectedMultiValue.push(genreValue);
      console.log("array", selectedMultiValue);
    }

    if(ratingValue!==null){
      ratings=ratingValue;
    }

    if(searchValue!==null){
      searchBarValue=searchValue;
    }

    try {
     
      const response = await axios.get(`${config.endpoint}`, {
        params: {
          title: searchBarValue ? searchBarValue : undefined,
          genres: selectedMultiValue ? selectedMultiValue : undefined,
          contentRating: ratings ? ratings : undefined,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      console.log("perform API search", response.data);
      setVideos(response.data["videos"]);
    } catch (err) {
      console.log(err);
    }
  };

  const debounceSearch = (event) => {
    if (debounceTimeout) clearTimeout(debounceTimeout);

    const timeout = setTimeout(() => {
      return performAPISearch(event.target.value);
    }, 500);

    setDebounceTimeout(timeout);
  };

  const showUploadModal=()=>{
    setShowModal(true);  
  }

  return (
    <>
    {showModal && <UploadModal closeModal={setShowModal}></UploadModal> }
      <div className="container">
        <div className="navigation">
          <Stack
            direction="row"
            spacing={3}
            justifyContent="space-between"
            mr={2.5}
            ml={2.5}
            alignItems="center"
          >
            <img src={logo} alt="xflix logo" className="logo"></img>

            <div className="search-bar">
              <TextField
                fullWidth
                sx={{
                  backgroundColor: "#121212",
                  border: "none",
                  input: { color: "#606060" },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search color="#606060" placeholder="Search for videos" />
                    </InputAdornment>
                  ),
                }}
                placeholder="Search"
                name="search"
                onChange={debounceSearch}
              />
            </div>
            <Button
              color="secondary"
              variant="contained"
              className="button_upload"
              onClick={showUploadModal}
            >
              <FileUpload></FileUpload>
              UPLOAD
            </Button>
          </Stack>
        </div>
        <header className="header">
          <SortButton filterResults={performAPISearch} sortResults={performAPISort}></SortButton>
        </header>
      </div>

      <section color="primary" className="section">
        <Grid container spacing={3}>
          {Videos.map((ele) => {
            return (
              <Grid item lg={3} xs={12} sm={6} key={ele._id}>
                <LandingPageVideo video={ele}></LandingPageVideo>
              </Grid>
            );
          })}
        </Grid>
      </section>
    </>
  );
};

export default LandingPage;
